import { defaultConfig } from 'app/config/environment';
import axios from 'axios';

/**
 * Realiza una suba de un fichero
 * @param {*} file Fichero elegido por el usuario
 * @param {*} token Este parametro generalmente nos lo da el ticket que se pide previamente
 * @param {*} endpoint Este parametro generalmente nos lo da el ticket que se pide previamente
 * @param {*} onProgressChange Funcion que se invocara actualizando el porcentaje de subida
 * @param {*} fileName Nombre del fichero opcional sino va a coger file.name
 * @param {*} baseUrl Es la url que le pondrá al principio al endpoint para realizar la llamada.
 *                    Hay veces que para la base podemos querer hacer esta logica:
 * @param {*} fileType Tipo de archivo que queremos subir puede ser 'file' o 'blob'
 */
export const sendRequest = (file, token, endpoint, onProgressChange, fileName, baseUrl, fileType = 'file') => {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.upload.addEventListener('progress', (event) => {
      const percentage = (event.loaded / event.total) * 100;
      onProgressChange && onProgressChange(parseInt(percentage));
    });
    req.upload.addEventListener('load', (event) => {});
    req.upload.addEventListener('error', (event) => {
      reject(req.response);
    });
    req.upload.addEventListener('abort', (event) => {
      reject(req.response);
    });
    req.onreadystatechange = () => {
      if (req.status) {
        if (req.status === 200) {
          resolve(req.response);
        } else {
          reject(req.response);
        }
      }
    };
    const formData = new FormData();
    const filename = fileName ? fileName : file.name;
    if (fileType === 'file') formData.append('file', file, filename);
    if (fileType === 'blob') formData.append('blob', file);
    formData.append('token', token);
    const endpointFinal = `${baseUrl}${endpoint}`;
    req.open('POST', endpointFinal);
    req.onreadystatechange = function (oEvent) {
      if (req.readyState === 4) {
        if (req.status === 200) {
          resolve(req);
        } else {
          reject(req);
        }
      }
    };
    req.send(formData);
  });
};

function getHeaders() {
  return { headers: { 'app-referer': defaultConfig.BASE_URL_ } };
}

function getBaseUrl() {
  return defaultConfig.BASE_URL_;
}

export async function uploadFilePhoto({
  blob,
  file,
  fileName,
  urlToken,
  onEnd = () => null,
  onProgress = () => null,
  openToast = () => null,
  setProgress = () => null,
}) {
  const fileType = blob ? 'blob' : 'file';

  function onProgressChange(event) {
    onProgress(event);
  }

  try {
    const { data } = await axios.get(urlToken, getHeaders());
    let { token, endpoint } = data.data;
    const baseUrl = getBaseUrl();

    // Fix double slash issue: remove leading slash if endpoint contains /files-storage/
    if (endpoint && endpoint.includes('/files-storage/')) {
      endpoint = endpoint.substr(1);
    }

    sendRequest(file, token, endpoint, onProgressChange, fileName, baseUrl, fileType).then(() => {
      onEnd();
      setProgress(0);
    });
  } catch (error) {
    openToast({ error });
    setProgress(0);
  }
}
